import events from './events'
function reducer(h) {
  const {
    showTcc,
    closeTcc
  } = events();
  return (type, ...arg) => {
    switch (type) {
      case 'showTcc':
        showTcc(...arg);
        break;
      case 'closeTcc':
        closeTcc(...arg);
        break;
    }
  }
}

export default reducer;
